import React, { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { saveAnswer } from '../Apis/endpoints'; // Adjust the import path
import { useLocation } from "react-router-dom";

const Intro2 = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const navigate = useNavigate();

  const question = "What are you trying to achieve?";
  const options = [
    { id: 1, text: "Confident Speaking Skills" },
    { id: 2, text: "Working Professional" },
    { id: 3, text: "Educator" },
    { id: 4, text: "Just Learning a Language" },
  ];


  const handleBackClick = () => {
    navigate('/intro1'); 
  };

  const handleOptionClick = async (optionId) => {
    setSelectedOption(optionId);
    const selectedAnswer = options.find((option) => option.id === optionId).text;

    // Save or update the answer in the backend
    await saveAnswer(question, selectedAnswer);

    // Redirect to the next page
    setTimeout(() => {
      navigate('/upload');
    }, 500);
  };


  return (
    <div className="flex flex-wrap h-screen bg-gradient-to-r from-gray-100 to-blue-50"
    style={{
      backgroundImage: "url('/images/background.svg')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    }}>
      {/* Back Button */}
      <div className="absolute top-6 left-6 sm:top-8 sm:left-8 md:top-10 md:left-10 lg:top-12 lg:left-12 z-20">
        <button
          className="flex items-center justify-center hover:bg-gray-100 transition px-3 py-2 rounded-lg"
          onClick={handleBackClick}
        >
        {/* Back Icon as a background image */}
        <span
          className="w-4 h-4 sm:w-8 sm:h-8 md:w-6 md:h-6"
          style={{
            backgroundImage: "url('/images/Back-icon.svg')",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "inline-block",
          }}
        ></span>

        {/* Back Text */}
        <span
          className="ml-2 text-sm sm:text-base md:text-lg"
          style={{ fontFamily: "'Archivo', sans-serif" }}
        >
          Back
        </span>
      </button>
    </div>

      {/* Left Section: Question and Options */}
      <div className="flex flex-1 justify-center items-center p-8 min-w-[50%]">
        <div className="w-full max-w-[30rem] p-8 text-left">
        <h2 className="mb-8 text-[#002952] text-lg font-semibold">{question}</h2>
        {options.map((option) => (
            <div
              key={option.id}
              onClick={() => handleOptionClick(option.id)}
              className={`flex items-center p-4 my-6 w-[80%] max-w-[20rem] rounded-lg cursor-pointer transition-all duration-300 shadow-md ${
                selectedOption === option.id
                  ? "bg-[#2C72F2] text-white"
                  : "bg-[#FFFFFF] text-[#002952]"
              }`}
            >
              <span
                className={`mr-3 flex items-center justify-center text-lg ${
                  selectedOption === option.id ? "text-white" : "text-gray-800"
                }`}
              >
                <img
                  src="/images/onboard-icon.svg" // Update this path based on your actual file location
                  alt="Option Icon"
                  className=" mx-4 w-6 h-6 sm:w-8 sm:h-8 md:w-5 md:h-5"
                />
              </span>
              {option.text}
            </div>
          ))}
          <div className="mt-4">
            <a href="/upload" className="text-[#002952] underline text-base">
              Skip
            </a>
          </div>
        </div>
      </div>

      {/* Right Section: Video (Hidden on Mobile) */}
      {/* <div className="hidden md:flex flex-1 bg-white justify-center items-center p-8 min-w-[50%]">
        <div className="relative w-full max-w-[30rem]">
          <img
            src="/images/Soft_Skills.svg"
            alt="Soft Skills"
            className="max-w-full h-auto"
          />
        </div>
      </div>
    </div> */}
          {/* Right Section: Video (Hidden on Mobile) */}
      <div className="hidden md:flex flex-1 bg-white justify-center items-center p-8 min-w-[50%]">
        <div className="relative w-full max-w-[30rem] rounded-lg overflow-hidden">
          {/* Video */}
          <div className="relative pb-[56.25%] h-0"> {/* Aspect ratio container */}
          <img
              src="/images/onboard-page2.svg"
              alt="Feedback Meter"
              className="absolute top-4 left-0 w-[90%] h-[90%] rounded-lg"
            >

            </img>
          </div>
          {/* Tags */}
          <div className="absolute top-0 right-0">
            <div className=" text-white rounded-lg text-xs font-bold mb-2 h-[3rem] w-[13rem] flex flex-col">
              <div className=" h-[20%] flex items-center w-full rounded-t-lg"
                  style={{
                  background: 'linear-gradient(90deg, rgba(255, 100, 216, 0.6) 0%, rgba(78, 175, 249, 0.6) 54%, rgba(145, 60, 153, 0.6) 100%)',
                }}
                >
              </div>
                <div className="bg-white h-[80%] flex items-center w-full rounded-b-lg justify-between px-2">
                <div className="text-[#002952] text-sm font-medium font-archivo text-left">
                Confidence
                  </div>
                  <div className="text-[#C07907] text-md font-semibold text-left">
                  60%
                  </div>
                  <img
                    src="/images/FeedbackMeter.svg"
                    alt="Feedback Meter"
                    className="h-8 w-8 ml-2 mb-2"
                    />
                </div>
            </div>
            <div className=" text-white rounded-lg text-xs font-bold mb-2 h-[3rem] w-[13rem] flex flex-col">
              <div className=" h-[20%] flex items-center w-full rounded-t-lg"
                  style={{
                  background: 'linear-gradient(90deg, rgba(255, 100, 216, 0.6) 0%, rgba(78, 175, 249, 0.6) 54%, rgba(145, 60, 153, 0.6) 100%)',
                }}
                >
              </div>
                <div className="bg-white h-[80%] flex items-center w-full rounded-b-lg justify-around px-2">
                <div className="text-[#002952] text-sm font-medium font-archivo text-left">
                  Filler Words
                  </div>
                  <div className="text-[#00A827] text-md font-semibold text-left">
                     20%
                  </div>
                  <img
                    src="/images/Group1261153778.svg"
                    alt="Feedback Meter"
                    className="h-8 w-8 ml-2 mb-2"
                    />
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro2;
